import React from "react";

import defaultStyles from "./main.module.scss";

const defaultValidate = (e) => e;

export const TextInput = React.forwardRef(
  (
    {
      onChange = null,
      onFocus = null,
      onBlur = null,
      onClick = null,
      onPaste = null,
      validate = defaultValidate,
      autoComplete = "on",
      label = null,
      placeholder = "",
      classes = "",
      id = `input-${Date.now()}`,
      shouldAutoFocus = false,
      name = "text-input",
      value = "",
      type = "text",
      disabled = false,
      error = false,
      readOnly = false,
      tabIndex = 0,
      onKeyPress = null,
      prefix = null,
      inputmode = "text",
      className = "",
      styles = defaultStyles,
    },
    ref
  ) => (
    <div className={`${styles.formInput} ${classes} ${error ? styles.formInputError : ""}`}>
      {label && React.cloneElement(label, { disabled, htmFor: id })}
      <span>
        {prefix}
        <input
          type={type}
          placeholder={placeholder}
          name={name}
          id={id}
          className={`${styles.inputClass} ${className}`}
          ref={ref}
          disabled={disabled}
          readOnly={readOnly}
          autoFocus={shouldAutoFocus}
          value={value}
          tabIndex={tabIndex}
          autoComplete={autoComplete}
          onChange={(e) => onChange(validate({ name: e.target.name, value: e.target.value }))}
          onClick={onClick}
          onFocus={onFocus}
          onBlur={onBlur}
          onPaste={onPaste}
          onKeyPress={onKeyPress}
          inputMode={inputmode}
        />
        {label && <label htmlFor={id} className={styles.animatedLine} />}
      </span>
    </div>
  )
);
